import { gql } from 'graphql-request'

export const GET_ORGANISATION_TEAM_STATS = gql`
  query getOrganisationTeamStats($organisationId: Int!, $windowDays: Int) {
    getOrganisationTeamStats(organisationId: $organisationId, windowDays: $windowDays) {
      kpis {
        activeReps
        totalReps
        windowDays
        sessionsCurrent
        sessionsPrevious
        avgScoreCurrent
        avgScorePrevious
      }
      modules {
        moduleId
        moduleName
        rolePlayCount
        enrolledCount
        completionPct
        avgScore
        masteredCount
        masteredTotal
      }
      members {
        userId
        email
        firstName
        lastName
        totalSessions
        avgScore
        lastActiveAt
        masteredCount
      }
    }
  }
`

export interface TeamStatsKpis {
  activeReps: number
  totalReps: number
  windowDays: number
  sessionsCurrent: number
  sessionsPrevious: number
  avgScoreCurrent: number
  avgScorePrevious: number
}

export interface TeamStatsModule {
  moduleId: number
  moduleName: string
  rolePlayCount: number
  enrolledCount: number
  completionPct: number
  avgScore: number
  masteredCount: number
  masteredTotal: number
}

export interface TeamStatsMember {
  userId: number
  email: string
  firstName: string | null
  lastName: string | null
  totalSessions: number
  avgScore: number
  lastActiveAt: string | null
  masteredCount: number
}

export interface OrganisationTeamStats {
  kpis: TeamStatsKpis
  modules: TeamStatsModule[]
  members: TeamStatsMember[]
}
